'use client';

import React from 'react'
import Image from 'next/image';

// Assets
import Pin from "@public/png/pin-1.png"
import Envelope from "@public/png/envelope-1.png"
import Phone from "@public/png/phone-3.png"
import Printer from "@public/png/printer-1.png"

const Contact = ({ src, text }) => {
  return (
    <div className='flex mb-4'>
      <Image
        src={src}
        alt='Vectors'
        width="auto"
        height="auto"
        className='w-[20px] h-[20px] mr-2 object-contain'
      />

      <p className='text-17 text-black-1'>{text}</p>
    </div>
  )
}

const InfoContact = () => {
  return (
    <div>
      <p className='text-52 font-sfpro-bold mb-4'>KONTAK</p>
      <Contact
        src={Pin}
        text="Ciputra World Jakarta 2 - Tokopedia Tower 7th Floor Jl. Prof. Dr. Satrio Kav 11 Karet Semanggi - Setiabudi - Jakarta Selatan"
      />
      <Contact
        src={Envelope}
        text="support@century21.co.id"
      />
      <Contact
        src={Phone}
        text="021-2988-2121"
      />
      <Contact
        src={Printer}
        text="021-29688711"
      />
    </div>
  )
}

export default InfoContact